import React from "react";
import "./ServiceSection.css";

// Import your service images (you'll need to add these images to your project)
import webDevIcon from "../assets/images/code-icon.png";
import digitalMarketingIcon from "../assets/images/digitalmarketing-icon.png";
import graphicsDesignIcon from "../assets/images/design-icon.png";
import photographyIcon from "../assets/images/photography-icon.png";
import printIcon from "../assets/images/print-on-demand-line-icon-illust.png";
import AppIcon from "../assets/images/app-dev-icon.png";

const ServiceSection = () => {
  const services = [
    {
      title: "Web Development",
      desc: "Custom, responsive websites built with the latest technologies.",
      icon: webDevIcon,
    },

    {
      title: "Digital Marketing",
      desc: "Strategic campaigns that drive traffic and boost conversions.",
      icon: digitalMarketingIcon,
    },
    {
      title: "Mobile App Development",
      desc: "Custom user-friendly mobile applications that deliver seamless experiences and scalable business growth.",
      icon: AppIcon,
    },
    {
      title: "Graphic Design",
      desc: "Eye-catching designs that capture your brand essence",
      icon: graphicsDesignIcon,
    },
    {
      title: "Photography",
      desc: "Professional photography services for your business needs.",
      icon: photographyIcon,
    },
    {
      title: "Printing",
      desc: "Print on demand everything important for your business.",
      icon: printIcon,
    },
  ];

  return (
    <section id="services" className="services-section py-5">
      <div className="container">
        <div className="services-header text-center mb-5">
          <h3 className="services-title fw-bold mb-3">What We Offer</h3>
          <p className="services-subtitle text-muted">
            We provide end-to-end digital solutions that transform ideas into
            powerful online experiences through strategy, design, and
            technology.
          </p>
        </div>
        <div className="row g-4">
          {services.map((service, index) => (
            <div className="col-md-6 col-lg-3" key={index}>
              <div className="service-card text-center p-4 h-100">
                <div className="service-icon mb-3">
                  <img
                    src={service.icon}
                    alt={service.title}
                    className="service-image"
                  />
                </div>
                <h4 className="service-card-title fw-bold mb-3">
                  {service.title}
                </h4>
                <p className="service-card-desc text-muted">{service.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
